export default "__VITE_ASSET__BBf1ngG4__"